/** @format */

import template from './gb-raffle-item-amount.html';

export const GbRaffleItemAmountComponent = {
    template,
    require: {
        gbApp: '^^',
    },
    bindings: {
        raffleItem: '<',
    },
    controller: class GbRaffleItemAmountComponent {
        constructor() {
            'ngInject';
        }
    },
};
